module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_mobile_4-9a35e39d00040100d2cd8aee2af3d4cb.png";